/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * rain/v1/generator_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  GeneratorServiceGetDynamicGeneratorConfigSchemaBody,
  GeneratorServiceSetGeneratorBody,
  GeneratorServiceValidateGeneratorConfigSchemaBody,
  RpcStatus,
  V1DiffGeneratorResponse,
  V1DynamicEnumValuesResponse,
  V1GenerateRequest,
  V1Generator,
  V1GetConfigSchemaResponse,
  V1ListGeneratorDynamicEnumValuesRequest,
  V1ListGeneratorKindsResponse,
  V1ValidateConfigResponse,
  WorkspaceClearGeneratorParams,
  WorkspaceDiffGeneratorParams,
  WorkspaceGenerate200,
  WorkspaceGetGeneratorParams,
  WorkspaceGetStaticGeneratorConfigSchemaParams,
} from '../../models';

/**
 * @summary Dynamic (layer-2) config schema for a generator kind, derived from its static values.
 */
export const workspaceGetDynamicGeneratorConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  generatorServiceGetDynamicGeneratorConfigSchemaBody: GeneratorServiceGetDynamicGeneratorConfigSchemaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/generator:dynamic-config`,
    generatorServiceGetDynamicGeneratorConfigSchemaBody,
    options,
  );
};

export const getWorkspaceGetDynamicGeneratorConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceGetDynamicGeneratorConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: GeneratorServiceGetDynamicGeneratorConfigSchemaBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceGetDynamicGeneratorConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: GeneratorServiceGetDynamicGeneratorConfigSchemaBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceGetDynamicGeneratorConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceGetDynamicGeneratorConfigSchema>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: GeneratorServiceGetDynamicGeneratorConfigSchemaBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceGetDynamicGeneratorConfigSchema(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceGetDynamicGeneratorConfigSchemaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceGetDynamicGeneratorConfigSchema>>
  >;
export type WorkspaceGetDynamicGeneratorConfigSchemaMutationBody =
  GeneratorServiceGetDynamicGeneratorConfigSchemaBody;
export type WorkspaceGetDynamicGeneratorConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Dynamic (layer-2) config schema for a generator kind, derived from its static values.
 */
export const useWorkspaceGetDynamicGeneratorConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceGetDynamicGeneratorConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: GeneratorServiceGetDynamicGeneratorConfigSchemaBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceGetDynamicGeneratorConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: GeneratorServiceGetDynamicGeneratorConfigSchemaBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceGetDynamicGeneratorConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Static (layer-1) config schema for a generator kind.
 */
export const workspaceGetStaticGeneratorConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticGeneratorConfigSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/generator:static-config`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetStaticGeneratorConfigSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  params?: WorkspaceGetStaticGeneratorConfigSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/generator:static-config`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetStaticGeneratorConfigSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticGeneratorConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetStaticGeneratorConfigSchemaQueryKey(
      organization,
      workspace,
      agentId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>
  > = ({ signal }) =>
    workspaceGetStaticGeneratorConfigSchema(
      organization,
      workspace,
      agentId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetStaticGeneratorConfigSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>
>;
export type WorkspaceGetStaticGeneratorConfigSchemaQueryError =
  AxiosError<RpcStatus>;

export function useWorkspaceGetStaticGeneratorConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticGeneratorConfigSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticGeneratorConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticGeneratorConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticGeneratorConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticGeneratorConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Static (layer-1) config schema for a generator kind.
 */

export function useWorkspaceGetStaticGeneratorConfigSchema<
  TData = Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticGeneratorConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticGeneratorConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetStaticGeneratorConfigSchemaQueryOptions(
    organization,
    workspace,
    agentId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary ============================================================================
Validation
============================================================================
Validates a generator's configuration without saving.
 */
export const workspaceValidateGeneratorConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  generatorServiceValidateGeneratorConfigSchemaBody: GeneratorServiceValidateGeneratorConfigSchemaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ValidateConfigResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/generator:validate`,
    generatorServiceValidateGeneratorConfigSchemaBody,
    options,
  );
};

export const getWorkspaceValidateGeneratorConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceValidateGeneratorConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: GeneratorServiceValidateGeneratorConfigSchemaBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceValidateGeneratorConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: GeneratorServiceValidateGeneratorConfigSchemaBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceValidateGeneratorConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceValidateGeneratorConfigSchema>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: GeneratorServiceValidateGeneratorConfigSchemaBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceValidateGeneratorConfigSchema(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceValidateGeneratorConfigSchemaMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceValidateGeneratorConfigSchema>>
>;
export type WorkspaceValidateGeneratorConfigSchemaMutationBody =
  GeneratorServiceValidateGeneratorConfigSchemaBody;
export type WorkspaceValidateGeneratorConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Validation
============================================================================
Validates a generator's configuration without saving.
 */
export const useWorkspaceValidateGeneratorConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceValidateGeneratorConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: GeneratorServiceValidateGeneratorConfigSchemaBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceValidateGeneratorConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: GeneratorServiceValidateGeneratorConfigSchemaBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceValidateGeneratorConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns the thread's per-thread customization if one is set, otherwise the
generator from the agent template the thread is pinned to.
 * @summary ============================================================================
Generator Management (thread-scoped)
============================================================================
Gets the effective generator for a thread.
 */
export const workspaceGetGenerator = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetGeneratorParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Generator>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/generator`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetGeneratorQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceGetGeneratorParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/generator`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetGeneratorQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceGetGenerator>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetGenerator>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetGeneratorQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetGenerator>>
  > = ({ signal }) =>
    workspaceGetGenerator(organization, workspace, agentId, threadId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetGenerator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetGeneratorQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGetGenerator>>
>;
export type WorkspaceGetGeneratorQueryError = AxiosError<RpcStatus>;

export function useWorkspaceGetGenerator<
  TData = Awaited<ReturnType<typeof workspaceGetGenerator>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceGetGeneratorParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetGenerator>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetGenerator>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetGenerator<
  TData = Awaited<ReturnType<typeof workspaceGetGenerator>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceGetGenerator>>,
          TError,
          Awaited<ReturnType<typeof workspaceGetGenerator>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetGenerator<
  TData = Awaited<ReturnType<typeof workspaceGetGenerator>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetGenerator>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Generator Management (thread-scoped)
============================================================================
Gets the effective generator for a thread.
 */

export function useWorkspaceGetGenerator<
  TData = Awaited<ReturnType<typeof workspaceGetGenerator>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceGetGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetGenerator>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceGetGeneratorQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Marks the thread's generator as explicitly "no generator" (distinct
from `ThreadAgentService::ResetConfig`, which drops the entire
override).
 * @summary Clears the generator customization for a thread.
 */
export const workspaceClearGenerator = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceClearGeneratorParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Generator>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/generator`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceClearGeneratorMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceClearGenerator>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      params?: WorkspaceClearGeneratorParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceClearGenerator>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    params?: WorkspaceClearGeneratorParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceClearGenerator'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceClearGenerator>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      params?: WorkspaceClearGeneratorParams;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, params } = props ?? {};

    return workspaceClearGenerator(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceClearGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceClearGenerator>>
>;

export type WorkspaceClearGeneratorMutationError = AxiosError<RpcStatus>;

/**
 * @summary Clears the generator customization for a thread.
 */
export const useWorkspaceClearGenerator = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceClearGenerator>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        params?: WorkspaceClearGeneratorParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceClearGenerator>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    params?: WorkspaceClearGeneratorParams;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceClearGeneratorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Lazy-forks the full agent config into a per-thread customization on first
call. Validates the generator config before saving.
 * @summary Sets the generator customization for a thread.
 */
export const workspaceSetGenerator = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  generatorServiceSetGeneratorBody: GeneratorServiceSetGeneratorBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Generator>> => {
  return axios.default.put(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/generator`,
    generatorServiceSetGeneratorBody,
    options,
  );
};

export const getWorkspaceSetGeneratorMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceSetGenerator>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: GeneratorServiceSetGeneratorBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceSetGenerator>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: GeneratorServiceSetGeneratorBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceSetGenerator'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceSetGenerator>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: GeneratorServiceSetGeneratorBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceSetGenerator(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceSetGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceSetGenerator>>
>;
export type WorkspaceSetGeneratorMutationBody =
  GeneratorServiceSetGeneratorBody;
export type WorkspaceSetGeneratorMutationError = AxiosError<RpcStatus>;

/**
 * @summary Sets the generator customization for a thread.
 */
export const useWorkspaceSetGenerator = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceSetGenerator>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: GeneratorServiceSetGeneratorBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceSetGenerator>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: GeneratorServiceSetGeneratorBody;
  },
  TContext
> => {
  const mutationOptions = getWorkspaceSetGeneratorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Returns both the thread's effective generator and the pinned agent
version's generator, so callers can render a base→override diff
without two requests.
 */
export const workspaceDiffGenerator = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffGeneratorParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiffGeneratorResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/generator:diff`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDiffGeneratorQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceDiffGeneratorParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/generator:diff`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceDiffGeneratorQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceDiffGenerator>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffGenerator>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceDiffGeneratorQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceDiffGenerator>>
  > = ({ signal }) =>
    workspaceDiffGenerator(organization, workspace, agentId, threadId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceDiffGenerator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceDiffGeneratorQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDiffGenerator>>
>;
export type WorkspaceDiffGeneratorQueryError = AxiosError<RpcStatus>;

export function useWorkspaceDiffGenerator<
  TData = Awaited<ReturnType<typeof workspaceDiffGenerator>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceDiffGeneratorParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDiffGenerator>>,
          TError,
          Awaited<ReturnType<typeof workspaceDiffGenerator>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceDiffGenerator<
  TData = Awaited<ReturnType<typeof workspaceDiffGenerator>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDiffGenerator>>,
          TError,
          Awaited<ReturnType<typeof workspaceDiffGenerator>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceDiffGenerator<
  TData = Awaited<ReturnType<typeof workspaceDiffGenerator>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffGenerator>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns both the thread's effective generator and the pinned agent
version's generator, so callers can render a base→override diff
without two requests.
 */

export function useWorkspaceDiffGenerator<
  TData = Awaited<ReturnType<typeof workspaceDiffGenerator>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffGenerator>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceDiffGeneratorQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists available generator kinds and their configuration schemas.
 */
export const workspaceListGeneratorKinds = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListGeneratorKindsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/generators/kinds`,
    options,
  );
};

export const getWorkspaceListGeneratorKindsQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/generators/kinds`,
  ] as const;
};

export const getWorkspaceListGeneratorKindsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListGeneratorKindsQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListGeneratorKinds>>
  > = ({ signal }) =>
    workspaceListGeneratorKinds(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListGeneratorKindsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListGeneratorKinds>>
>;
export type WorkspaceListGeneratorKindsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListGeneratorKinds<
  TData = Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListGeneratorKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListGeneratorKinds<
  TData = Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListGeneratorKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListGeneratorKinds<
  TData = Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists available generator kinds and their configuration schemas.
 */

export function useWorkspaceListGeneratorKinds<
  TData = Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListGeneratorKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListGeneratorKindsQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Re-resolves the dynamic option list for one generator config field.
Used by UIs to power "refresh" buttons next to dropdowns whose options
depend on values the user is currently editing in the form (e.g.,
refreshing the model list against a custom Ollama endpoint).
 */
export const workspaceListGeneratorDynamicEnumValues = (
  organization: string,
  workspace: string,
  v1ListGeneratorDynamicEnumValuesRequest: V1ListGeneratorDynamicEnumValuesRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DynamicEnumValuesResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/generators:dynamic-enum-values`,
    v1ListGeneratorDynamicEnumValuesRequest,
    options,
  );
};

export const getWorkspaceListGeneratorDynamicEnumValuesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceListGeneratorDynamicEnumValues>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: V1ListGeneratorDynamicEnumValuesRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceListGeneratorDynamicEnumValues>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: V1ListGeneratorDynamicEnumValuesRequest;
  },
  TContext
> => {
  const mutationKey = ['workspaceListGeneratorDynamicEnumValues'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceListGeneratorDynamicEnumValues>>,
    {
      organization: string;
      workspace: string;
      data: V1ListGeneratorDynamicEnumValuesRequest;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return workspaceListGeneratorDynamicEnumValues(
      organization,
      workspace,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceListGeneratorDynamicEnumValuesMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListGeneratorDynamicEnumValues>>
>;
export type WorkspaceListGeneratorDynamicEnumValuesMutationBody =
  V1ListGeneratorDynamicEnumValuesRequest;
export type WorkspaceListGeneratorDynamicEnumValuesMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Re-resolves the dynamic option list for one generator config field.
Used by UIs to power "refresh" buttons next to dropdowns whose options
depend on values the user is currently editing in the form (e.g.,
refreshing the model list against a custom Ollama endpoint).
 */
export const useWorkspaceListGeneratorDynamicEnumValues = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceListGeneratorDynamicEnumValues>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: V1ListGeneratorDynamicEnumValuesRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceListGeneratorDynamicEnumValues>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: V1ListGeneratorDynamicEnumValuesRequest;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceListGeneratorDynamicEnumValuesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This is a stateless generation endpoint that does not create a thread
or persist any events. Suitable for simple text transformation tasks
like rewriting, summarizing, or enhancing content.

Returns a stream of Event objects (OutputText, GenerationComplete, etc.)
using the same event architecture as thread streaming.

For browser clients, use the SSE endpoint at:
POST /agents/{agent_id}/generator:generate
 * @summary ============================================================================
Text Generation
============================================================================
Generates text using the agent's generator (gRPC streaming).
 */
export const workspaceGenerate = (
  organization: string,
  workspace: string,
  v1GenerateRequest: V1GenerateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceGenerate200>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/rain.v1.GeneratorService/Generate`,
    v1GenerateRequest,
    options,
  );
};

export const getWorkspaceGenerateMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceGenerate>>,
    TError,
    { organization: string; workspace: string; data: V1GenerateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceGenerate>>,
  TError,
  { organization: string; workspace: string; data: V1GenerateRequest },
  TContext
> => {
  const mutationKey = ['workspaceGenerate'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceGenerate>>,
    { organization: string; workspace: string; data: V1GenerateRequest }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return workspaceGenerate(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceGenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceGenerate>>
>;
export type WorkspaceGenerateMutationBody = V1GenerateRequest;
export type WorkspaceGenerateMutationError = AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Text Generation
============================================================================
Generates text using the agent's generator (gRPC streaming).
 */
export const useWorkspaceGenerate = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceGenerate>>,
      TError,
      { organization: string; workspace: string; data: V1GenerateRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceGenerate>>,
  TError,
  { organization: string; workspace: string; data: V1GenerateRequest },
  TContext
> => {
  const mutationOptions = getWorkspaceGenerateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
